import { Typography } from "@mui/material";
import { useMobileLayout } from "@verity/components";
import { CoreButton } from "@verity/components/core";
import { useNavigate } from "react-router-dom";
import apiClient from "../../../../../helpers/api-client";
import i18n from "../../../../../i18n";
import { genToastInstance } from "../../../../shared";
import { MonitoringIcon, PlatformIcon, RatingsIcon, RightArrowIcon } from "./assets";
import ActionCard from "./components/ActionCard";
import { InfoCard } from "./components/InfoCard";
import styles from "./InterviewInstructorWelcomePage.module.css";

const toastInstance = genToastInstance("InterviewsPage");

export default function InterviewInstructorWelcomePage() {
	const isMobileLayout = useMobileLayout();
	const navigate = useNavigate();

	return (
		<div className={styles.pageWrapper}>
			<div className={isMobileLayout ? styles.pageContainerCompact : styles.pageContainer}>
				<div className={styles.page}>
					<div className={styles.pageContent}>
						<div className={styles.hero}>
							<iframe
								className={styles.overlay}
								allowFullScreen
								src="https://marketing.video.yuja.com/V/Video?v=15695953&node=67703127&a=115940241"
							/>
						</div>

						<div className={styles.pageText}>
							<Typography className={styles.title}>
								{i18n.t(`candidate.instructorHomePage.welcomeText.title`)}
							</Typography>
							<Typography className={styles.description}>
								{i18n.t(`candidate.instructorHomePage.welcomeText.description`)}
							</Typography>
						</div>

						<div className={isMobileLayout ? styles.cardsRowCompact : styles.cardsRow}>
							<InfoCard icon={<MonitoringIcon />} text={i18n.t(`candidate.instructorHomePage.infoCards.monitoring`)} />
							<InfoCard icon={<PlatformIcon />} text={i18n.t(`candidate.instructorHomePage.infoCards.support`)} />
							<InfoCard icon={<RatingsIcon />} text={i18n.t(`candidate.instructorHomePage.infoCards.rating`)} />
						</div>
					</div>

					<ActionCard
						title={i18n.t(`candidate.instructorHomePage.actionCard.title`)}
						description={i18n.t(`candidate.instructorHomePage.actionCard.description`)}
						rightButton={
							<CoreButton
								onClick={() => {
									void apiClient.user.postHasShownCandidateWelcome();
									navigate("/interviews/schedule");
								}}
								endIcon={<RightArrowIcon />}
							>
								{i18n.t(`candidate.instructorHomePage.actionCard.buttonText`)}
							</CoreButton>
						}
					/>
				</div>
				{toastInstance.jsxElement}
			</div>
		</div>
	);
}
